export const createSVGData = (svgSource: string): string => {
  return `data:image/svg+xml;base64,${window.btoa(svgSource)}`;
};
